<template>
<ul :class="['nav flex-column sidebar']">
    <li v-for="item in _tabs" v-bind:key="item.id" class="nav-item tab-item">
        <router-link v-if="item.visible" :to="'/'+item.hash" :class="['nav-link', { active: item.active }]">
            <span v-if="item.html" v-html="item.html"></span>
            <span v-else>{{ item.text }}</span>
        </router-link>
    </li>

    <div class="sidebar-divider"></div>

    <li v-for="item in _links" v-bind:key="item.id" class="nav-item link-item">
        <router-link v-if="item.visible" :to="'/'+item.hash" :class="['nav-link', { active: item.active }]">
            <span v-if="item.html" v-html="item.html"></span>
            <span v-else>{{ item.text }}</span>
        </router-link>
    </li>
    
    <li class="nav-item link-item">
        <slot></slot>
    </li>
</ul>
</template>

<script>
export default {
    props: ['items'],
    computed:{
        _tabs() {
            var id= 0;
            var tabs = this.items.filter(i => i.type == "tab").map(item => {
                _.defaults(item, {
                    enable: true,
                    visible: true,
                });
                item.id = id++;
                item.active = false;
                return item;
            }).filter(item => item.visible);

            var activeTab = _.find(_.orderBy(tabs, t => t.hash.length, "desc"),
                                    t => this.$route.path.toLowerCase().startsWith(`/${t.hash}`));
            
            if (activeTab) activeTab.active = true;

            return tabs;
        },
        _links() {
            var id= 100;
            return this.items.filter(i => i.type != "tab").map(item => {
                _.defaults(item, {
                    enable: true,
                    visible: true,
                    active: false,
                    type: "link"
                });
                item.id = id++;
                return item;
            }).filter(item => item.visible);
        }
    }
}
</script>

<style scoped lang="scss">

.sidebar {
    min-width: 14rem;
    background-color: #fafafa;
    border-right: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    background-blend-mode: lighten;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow-x: hidden;
    overflow-y: hidden;

    .sidebar-divider {
        border-top: 1px lightgray solid;
        margin: 0.25rem 0;
    }

    li.nav-item.tab-item {
        margin: 0;
        background-color: transparent;

        a {
            color: #026d94 !important;
            font-size: 1.1rem;
            font-weight: 400;
            font-family: 'Roboto','Open Sans',sans-serif;
        }

        a:hover {
            background-color: #e1f6ff;
            border: 0px;
        }

        a.active {
            font-weight: 500;
            background-color: #c0e3f0;
            color: #525252 !important;
        }
    }

    li.nav-item.link-item {
        margin: .05rem 0;
        // padding-left: 1.5rem;
        background-color: transparent;
        a {
            font-size: 0.8rem;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/framework/SideBar.vue